import React, { useState, useRef } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { SiFiverr } from 'react-icons/si';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    emailjs.sendForm(
      'service_3x53xpj', // Replace with your EmailJS service ID
      'template_8ixr3we', // Replace with your EmailJS template ID
      form.current,
      'ZzFPKbULbtMH61YkJ' // Replace with your EmailJS public key
    )
    .then(() => {
      setSuccess(true);
      form.current.reset();
    })
    .catch((error) => {
      setError('Failed to send message. Please try again.');
      console.error('EmailJS Error:', error);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">Contact Us</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-semibold mb-6">Send us a Message</h2>
            <form ref={form} onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="user_name" className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  name="user_name"
                  id="user_name"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500"
                />
              </div>
              
              <div>
                <label htmlFor="user_email" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="user_email"
                  id="user_email"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  name="message"
                  id="message"
                  rows={4}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                  loading
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500'
                }`}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>

              {error && (
                <div className="text-red-600 text-sm mt-2">
                  {error}
                </div>
              )}

              {success && (
                <div className="text-green-600 text-sm mt-2">
                  Message sent successfully! We'll get back to you soon.
                </div>
              )}
            </form>
          </div>

          {/* Contact Information */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-semibold mb-6">Get in Touch</h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <FaEnvelope className="text-teal-500 text-xl mt-1" />
                <div>
                  <h3 className="font-medium">Email</h3>
                  <p className="text-gray-600">online@aihairstylestudio.com</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaPhone className="text-teal-500 text-xl mt-1" />
                <div>
                  <h3 className="font-medium">Phone</h3>
                  <p className="text-gray-600">(+44) 07521967542</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <FaMapMarkerAlt className="text-teal-500 text-xl mt-1" />
                <div>
                  <h3 className="font-medium">Location</h3>
                  <p className="text-gray-600">131 Raglan Rd,<br />Birmingham, B66 3SR<br />United Kingdom</p>
                </div>
              </div>
            </div>
            {/* Developer Information */}
            <div className="mt-12 pt-6 border-t border-gray-200">
              <h2 className="text-2xl font-semibold mb-6">Developer Contact</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <FaEnvelope className="text-teal-500 text-xl mt-1" />
                  <div>
                    <h3 className="font-medium">Developer Email</h3>
                    <p className="text-gray-600">edwardkenvey6@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <SiFiverr className="text-teal-500 text-xl mt-1" />
                  <div>
                    <h3 className="font-medium">Developer Profile</h3>
                    <a 
                      href="https://www.fiverr.com/s/8zezbbz"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-500 hover:text-teal-600 transition-colors duration-200 flex items-center space-x-2"
                    >
                      <span>Developed by Shubhang</span>
                      <SiFiverr className="inline-block" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
